export default [
    {
      path: '/weeklyLuckyDraw/index',
      meta:{
        title: '每周签到幸运抽奖'
      },
      component: (resolve) => require(['@/pages/weeklyLuckyDraw/index'], resolve)
    },
  ]